import styled from 'styled-components';

export const StyledInputIcon = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${({ $prefix }) => $prefix && '15px'};
  right: ${({ $suffix }) => $suffix && '15px'};
  color: ${({ $invalid }) => ($invalid ? 'var(--danger)' : 'var(--text-muted)')};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  img,
  svg {
    display: block;
    color: inherit;
  }
  font-size: var(--font-size-lg);
  background: none;
  border: none;
  padding: 0;
  z-index: 0;
  line-height: 1;
  ${({ disabled }) => disabled && 'opacity: 0.5'};
  i {
    display: block;
  }
`;
